export const COLOR_KEYS = {
    max: 'success.lighter',
    min: 'error.lighter',
    neutral: '#FFFFFF',
    mainSite: 'primary.light'
}